import React, { Component } from 'react';
import ReactLoading from 'react-loading';
import Button from '../components/CustomButton/CustomButton';

export default class Loading extends Component {
  render() {
    return (
      <Button
        fill
        bsStyle="primary"
        style={{ marginRight: 10 }}
        onClick={this.props.onClick}
        disabled={this.props.disabled}
      >
        {this.props.disabled ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              cursor: 'default'
            }}
          >
            <ReactLoading
              type={'spin'}
              color={'white'}
              height={16}
              width={16}
            />
            <div style={{ marginLeft: 5 }}>Guardando</div>
          </div>
        ) : (
          'Guardar'
        )}
      </Button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ButtonSave.js